import {motion} from "framer-motion";
import styles from './About.module.css';

export default function About() {
    // Animation configs
    const imgAnim = {initial: {opacity: 0, x: -40}, whileInView: {opacity: 1, x: 0}};
    const imgAnimR = {initial: {opacity: 0, x: 40}, whileInView: {opacity: 1, x: 0}};
    const contentAnim = {initial: {opacity: 0, y: 36}, whileInView: {opacity: 1, y: 0}};

    return (
        <section className={styles.aboutSection}>
            <div className={styles.container}>
                <div className={styles.grid}>
                    {/* Left Image */}
                    <motion.div
                        {...imgAnim}
                        viewport={{once: true}}
                        transition={{duration: 0.6, delay: 0.10, ease: [0.23, 1, 0.32, 1]}}
                        className={styles.imageContainer}
                    >
                        <img
                            src="https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681ab310c5005628ac9c13cc_9bb84f3836acba0b2be6750efe167b46_about01.jpg"
                            alt="about asahi"
                            className={styles.image}
                            draggable={false}
                        />
                    </motion.div>

                    {/* Center Content */}
                    <motion.div
                        {...contentAnim}
                        viewport={{once: true}}
                        transition={{duration: 0.6, delay: 0.23, ease: [0.23, 1, 0.32, 1]}}
                        className={styles.centerContent}
                    >
                        <img
                            src="https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681ab10729e9ecbc96064c66_Scene01.png"
                            alt=""
                            className={styles.logo}
                            draggable={false}
                        />
                        <h2 className={styles.title}>
                            Asahi
                        </h2>
                        <p className={styles.description}>
                            Asahi is sharp craft and raw energy. Bold sushi, a loud room, nothing by the book.
                        </p>
                        {/* Underlined Link */}
                        <a
                            href="/contact"
                            className={styles.link}
                        >
              <span className={styles.linkSpan}>
                About Us
                <span
                    className={styles.underline}
                />
              </span>
                        </a>
                    </motion.div>

                    {/* Right Image */}
                    <motion.div
                        {...imgAnimR}
                        viewport={{once: true}}
                        transition={{duration: 0.6, delay: 0.16, ease: [0.23, 1, 0.32, 1]}}
                        className={styles.imageContainer}
                    >
                        <img
                            src="https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681ab3102b0d700b1cbca321_867e50d69ce3e4c23f8d0d928fb0f1c2_about02.jpg"
                            alt="about kanan"
                            className={`${styles.image} ${styles.rightImage}`}
                            draggable={false}
                        />
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
